import { render, staticRenderFns } from "./enterpriseTrain.vue?vue&type=template&id=45398255&scoped=true&"
import script from "./enterpriseTrain.vue?vue&type=script&lang=js&"
export * from "./enterpriseTrain.vue?vue&type=script&lang=js&"
import style0 from "./enterpriseTrain.vue?vue&type=style&index=0&id=45398255&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45398255",
  null
  
)

export default component.exports